const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    const popup = document.getElementById('delete-confirmation-popup');
    const addressDetailsEl = document.getElementById('delete-address-details');
    const popupConfirmBtn = document.getElementById('confirm-delete');
    const popupCancelBtn = document.getElementById('cancel-delete');
  
    // Get the HTML of the address being deleted
    const addressHTML = currentTarget
      .closest('[data-address]')
      .querySelector('.formatted-address')?.innerHTML;
  
    // Inject address details into popup
    addressDetailsEl.innerHTML = addressHTML || '<em>Address details unavailable</em>';
  
    // Show popup + add class to body
    popup.style.display = 'flex';
    document.body.classList.add('popup-open');
  
    // Clear previous event listeners
    popupConfirmBtn.replaceWith(popupConfirmBtn.cloneNode(true));
    popupCancelBtn.replaceWith(popupCancelBtn.cloneNode(true));
  
    const confirmBtn = document.getElementById('confirm-delete');
    const cancelBtn = document.getElementById('cancel-delete');
  
    cancelBtn.addEventListener('click', () => {
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
    });
  
    confirmBtn.addEventListener('click', () => {
      const deleteUrl = currentTarget.dataset.target;
  
      fetch(deleteUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: '_method=delete'
      }).then((res) => {
        if (res.ok) {
          currentTarget.closest('[data-address]').remove();
          popup.style.display = 'none';
          document.body.classList.remove('popup-open');
        } else {
          alert('Error deleting address. Please try again.');
        }
      });
    });
  };
}
